import { useSelector, useDispatch } from "react-redux";

import { Modal } from "antd";
import { showAppModal } from "~/redux/actions/app";
import { useRouter } from "next/router";
import { getUserInfo } from "~/redux/actions/user";
import { handleInsufficientEle } from "~/utils/ele";

/**
 * 电量使用组件，封装了电量不足提示和充值等动作
 *
 * @param {int} ele 需要花费的电量
 * @params {function} onAvailable 电量足够时的回调
 * @param {ReactNode} children 子组件
 */
const EleSpender = ({
  ele,
  onAvailable,
  children,
  confimation,
  preValidate,
}) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.user.token);

  const handleCharge = (balance, cost) => {
    handleInsufficientEle({
      balance,
      cost,
      dispatch,
      router,
    });
  };

  const handleClick = async () => {
    if (!preValidate) {
      handleConfirm();
      return;
    }

    await preValidate();
    handleConfirm();
  };

  const handleConfirm = () => {
    if (!confimation) {
      handle();
      return;
    }

    Modal.confirm({
      title: confimation.title,
      content: confimation.content,
      onOk: handle,
    });
  };

  const handle = () => {
    if (ele === 0) {
      onAvailable();
      return;
    }

    if (token) {
      // 检查电量前，先更新用户信息
      dispatch(
        getUserInfo(token, (user) => {
          if (user.ele && user.ele >= ele) {
            onAvailable();
          } else {
            handleCharge(user.ele, ele);
          }
        })
      );
    } else {
      dispatch(showAppModal("PhoneSigninModal"));
    }
  };

  return <div onClick={handleClick}>{children}</div>;
};

export default EleSpender;
